module.exports = __webpack_public_path__ + "static/media/envanterium-logo-text-only-light.86deb0a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Logo/envanterium-logo-text-only-light.png
// module id = 229
// module chunks = 0